import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/user/students/studentListContainer';
import { actions } from '../../../redux/user/students';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
